import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { PrivateRoute } from "./PrivateRoute";

import Login from "../src/components/Login/Login";
import Painel from "../src/components/Painel/Painel";
import Agendamento from "../src/components/TelaAgendamento/Agendamento";
import Reserva from "./components/Reservas/Reserva";
import Agenda from "./components/Agendas/Agendas";
import Caixa from "../src/components/Caixa/Caixa";
import Despesas from "../src/components/Financeiro/Despesas";
import Pacientes from "../src/components/Paciente/Pacientes";
import Dashboard from "../src/components/Dashboard/Dashboard";
import Empresas from "./components/Empresas/Empresas";
import Profissionais from "./components/Profissionais/Profissionais";
import Servicos from "./components/Servicos/Servicos";
import Pedidos from "./components/Pedidos/Pedidos";
import Usuarios from "./components/Usuarios/Usuarios";
import Arquivo from "./components/Arquivo/Arquivo";
import Relatorios from "./components/Relatorios/Relatorios";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

const App = () => (
  <div className="react-app-container">
    <Router basename="/app">
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/agendamento" element={<Agendamento />} />
          <Route path="/" element={<Navigate to="/agendamento" replace />} />

          <Route
            path="/painel"
            element={
              <PrivateRoute roles={["administrator", "editor"]}>
                <Painel />
              </PrivateRoute>
            }
          >
            <Route path="reserva" element={<Reserva />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="caixa" element={<Caixa />} />
            <Route path="financeiro" element={<Despesas />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="Empresas" element={<Empresas />} />
            <Route path="pacientes" element={<Pacientes />} />
            <Route path="Profissionais" element={<Profissionais />} />
            <Route path="Servicos" element={<Servicos />} />
            <Route path="Pedidos" element={<Pedidos />} />
            <Route path="Usuarios" element={<Usuarios />} />
            <Route path="Arquivo" element={<Arquivo />} />
            <Route path="Relatorios" element={<Relatorios />} />
            <Route index element={<Navigate to="dashboard" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
